module.exports = __webpack_public_path__ + "static/Caviar_Dreams_Bold-webfont-3dbee9128a3f4386c3c522c33d4acb71.woff";